import invertBy from 'lodash/invertBy';
import toLower from 'lodash/toLower';
import * as adapters from './generated';
export const baseUrl = 'https://rest.coincap.io/v3';
const apiKey = process.env.COINCAP_API_KEY || '';
export const coincapAssetUrl = `${baseUrl}/assets?limit=2000&apiKey=${apiKey}`;
const generatedAssetIdToCoinCapMap = Object.values(adapters).reduce((acc, cur) => ({
    ...acc,
    ...cur,
}));
const generatedCoincapToAssetIdsMap = invertBy(generatedAssetIdToCoinCapMap);
export const coincapToAssetIds = (id) => generatedCoincapToAssetIdsMap[id];
export const assetIdToCoinCap = (assetId) => generatedAssetIdToCoinCapMap[toLower(assetId)];
